import { render, staticRenderFns } from "./canteen.vue?vue&type=template&id=2da899d7"
import script from "./canteen.vue?vue&type=script&lang=js"
export * from "./canteen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports